export const TariffLine = {
  CHIPCORE: 'Chipcore Line'
}

export const State = {
  ACTIVE: 'Active',
  DISCOUNT: 'Discount',
  EOL: 'EOL'
}

export const Tag = {
  HWRAID: 'HWRAID',
  VROC: 'VROC',
  TWO_PSU: '2PSU'
}